<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="page-heading">
  <br>
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/home"><em class="la la-home font-20"></em></a>
    </li>
    <li class="breadcrumb-item">
      <span i18n="@@history">History</span>
    </li>
  </ol>
</div>

<div class="page-content fade-in-up">
  <div class="ibox">
    <div class="ibox-head">
      <div class="ibox-title" i18n="@@history">History</div>
    </div>

    <div class="ibox-body">
      <form [formGroup]="historyFG" (ngSubmit)="historyFormSubmit()">
        <div class="row">
          <div class=" col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-3">
            <app-select-third-parties controlName="thirdParty" [formGroup]="historyFG" [showLabel]="false"
                                      showValidation="no">
            </app-select-third-parties>
          </div>

          <div class=" col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 mb-3">
            <mat-form-field>
              <input matInput formControlName="dateStart" [matDatepicker]="pickerFrom" [max]="dateEndFC?.value"
                     i18n-placeholder="@@from" placeholder="From:">
              <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
              <mat-datepicker touchUi #pickerFrom disabled="false"></mat-datepicker>
            </mat-form-field>
          </div>

          <div class=" col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 mb-3">
            <mat-form-field>
              <input matInput formControlName="dateEnd" [matDatepicker]="pickerTo" [max]="today"
                     [min]="dateStartFC?.value" i18n-placeholder="@@to" placeholder="To:">
              <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
              <mat-datepicker touchUi #pickerTo disabled="false"></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="row mb-4">
          <div class=" col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <button type="submit" class="btn btn-success btn-rounded btn-block" i18n="@@search">Search</button>
          </div>
        </div>
      </form>

      <div class="row mb-4" *ngIf="0 < animals?.length">
        <div class=" col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <app-table-history-animals [data]="animals"></app-table-history-animals>
        </div>
      </div>

      <div class="row mb-4" *ngIf="0 < animals?.length">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <button class="btn btn-info btn-rounded btn-block" i18n="@@historyPrint" (click)="printHistory()">
            Print history
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
